module.exports = __webpack_public_path__ + "static/media/20ECE3.c54ad4b1.jpg";